import { LoadingButton } from "@mui/lab";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";

import { ampli } from "@/config";
import ModalForm from "@/elements/ModalForm.tsx";
import Locator from "@/locator.ts";
import { deleteItem } from "@/models/actions/clientActions.ts";

export default function ConfirmDeleteItem({
  open,
  itemId,
  setOpen,
  setPreventScroll,
}: {
  open: boolean;
  itemId: string;
  setOpen: (value: boolean) => void;
  setPreventScroll: (value: boolean) => void;
}) {
  const [deleting, setDeleting] = useState<boolean>(false);
  const handleDelete = async () => {
    try {
      setDeleting(true);
      ampli.deleteRecord({ itemId });
      await deleteItem(itemId);
      setOpen(false);
      setPreventScroll(true);
    } catch (e) {
      console.log(e);
    }
    setDeleting(false);
  };
  return (
    <ModalForm id="confirm-delete-message" open={open} onClose={() => setOpen(false)} disableClose={deleting}>
      <Box>
        <Typography sx={{ fontSize: 24 }}>Delete Message</Typography>
        <Typography sx={{ fontSize: 16, mb: 2 }}>
          Are you sure you want to delete this message from the feed?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: 2.5,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(false)}
            disabled={deleting}
            aria-label={Locator.feed.items.confirmMessageDeleteModal.cancel}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={deleting}
            variant="contained"
            color="error"
            sx={{ borderRadius: 6 }}
            onClick={handleDelete}
            aria-label={Locator.feed.items.confirmMessageDeleteModal.confirm}
          >
            Delete
          </LoadingButton>
        </Box>
      </Box>
    </ModalForm>
  );
}
